import { Box } from '@mui/material';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import React, { useEffect, useState } from 'react';
import useCifaStore from 'stores/cifa/cifa.store';
import { ROUTES } from 'routes/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewSchoolFeeding from './ViewSchoolFeeding';

type NumericStringNull = number | string | null;


interface SchoolFeedingValues {
    alimentacao_af_recurso_pnae: NumericStringNull;
    alimentacao_af_recurso_estado: NumericStringNull;
    alimentacao_af_recurso_prefeitura: NumericStringNull;
    alimentacao_total_recurso_pnae: NumericStringNull;
    alimentacao_total_recurso_estado: NumericStringNull;
    alimentacao_total_recurso_prefeitura: NumericStringNull;
    alimentacao_ata_aprovacao_uuid?: string | null;
}


const ViewSchoolFeedingPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cifa } = useCifaStore();

    // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
    const match = /cifa-(\d{4})/.exec(location.pathname);
    const anoReferencia = match ? Number(match[1]) : 2026;

    const [values, setValues] = useState<SchoolFeedingValues>({
        alimentacao_af_recurso_pnae: null,
        alimentacao_af_recurso_estado: null,
        alimentacao_af_recurso_prefeitura: null,
        alimentacao_total_recurso_pnae: null,
        alimentacao_total_recurso_estado: null,
        alimentacao_total_recurso_prefeitura: null,
        alimentacao_ata_aprovacao_uuid: null,
    });

    useEffect(() => {
        if (!cifa.uuid) {
            navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
            return;
        }
        setValues({
            alimentacao_af_recurso_pnae: cifa.alimentacao_af_recurso_pnae ?? null,
            alimentacao_af_recurso_estado: cifa.alimentacao_af_recurso_estado ?? null,
            alimentacao_af_recurso_prefeitura: cifa.alimentacao_af_recurso_prefeitura ?? null,
            alimentacao_total_recurso_pnae: cifa.alimentacao_total_recurso_pnae ?? null,
            alimentacao_total_recurso_estado: cifa.alimentacao_total_recurso_estado ?? null,
            alimentacao_total_recurso_prefeitura: cifa.alimentacao_total_recurso_prefeitura ?? null,
            alimentacao_ata_aprovacao_uuid: cifa.alimentacao_ata_aprovacao_uuid ?? null,
        });
    }, [cifa, navigate, anoReferencia, location.pathname]);

    return (
        <MenuProvider>
            <TopNavBar />
            <Header title={`CIFA - Visualização da Alimentação Escolar - ${anoReferencia}`} showBackButton={true} />
            <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>
                <ViewSchoolFeeding values={values} />
            </Box>
        </MenuProvider>
    );
};

export default ViewSchoolFeedingPage;
